import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import UploadDocument from "../../comman/UploadDocument";
import { getAlert } from "../../services/appAlerts";
import { getCurrentUser } from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import { AddEditBackgroundChecks, getBcAddEditStatus } from "../../app/store/candidate";

const AddBcChecks = (props) => {
  const { bcCheckShowHide, handleBcCheckShowHide, bcType,
    candidateObj, workItem, bcObject } = props;

  const [documents, setDocuments] = useState([]);
  const [saveBtnStatus, setSaveBtnStatus] = useState(false);
  const [bcStatus, setBcStatus] = useState(null);
  const [bcNotes, setBcNotes] = useState("");
  const [bcNotifyNotes, setBcNotifyNotes] = useState("");

  const bcAddEditStatusSelector = useSelector(getBcAddEditStatus);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(()=>{
    console.log(bcObject)
    if(bcObject){
      setBcNotifyNotes(bcObject.instructionNotes);
      setBcNotes(bcObject.notes);
      setBcStatus(bcObject.status);
    }
  },[bcObject])

  const doSubmit = async () => {
    if (bcType === "notify") {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to notify candidate!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        customClass: {
          confirmButton: 'swal2-outline-black',
          cancelButton: 'swal2-outline-red'
        },
        didOpen: () => {
          const confirmButton = Swal.getConfirmButton();
          confirmButton.innerHTML = `
                        <i class="fa fa-check" style="margin-right: 8px;"></i> Yes`;

          const cancelButton = Swal.getCancelButton();
          cancelButton.innerHTML = `
                        <i class="fa fa-times" style="margin-right: 8px; margin-left:3px;"></i> No`;
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          saveEditBackgroundCheck();
        } else {
          setSaveBtnStatus(false);
        }
      });
    } else {
      saveEditBackgroundCheck();
    }
  };

  const saveEditBackgroundCheck = async () => {
    setSaveBtnStatus(true);
    let data = { ...bcObject };
    data.performerId = candidateObj.performerid;
    data.addedBy = currentUser.id;
    data.notes = bcNotes;
    if (bcType === "notify")
      data.notes = bcNotifyNotes;

    data.status = bcStatus;
    const formData = new FormData();
    formData.append("BackgroundChecks", JSON.stringify(data));
    formData.append("workflowTask", JSON.stringify(workItem));
    formData.append("editType", bcType);
    documents.map((file, key) =>
      formData.append("files[" + key + "]", file.file)
    );

    dispatch(AddEditBackgroundChecks(formData));
  };


  useEffect(() => {
    if (bcAddEditStatusSelector) {
      getAlert("", "Saved Successfully", "success");
      setDocuments([]);
      setBcNotes("");
      setSaveBtnStatus(false);
      setBcNotifyNotes("");
      handleBcCheckShowHide("save", "");
    }
  }, [bcAddEditStatusSelector])

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        file: file,
        size: file.size,
      };
      docs.push(doc);
    }
    setDocuments(docs);
  };

  const handleFileRemove = (item) => {
    const index = documents.indexOf(item);
    let docs = [...documents];
    if (index !== -1) {
      docs.splice(index, 1);
      setDocuments(docs)
    }
  };

  return (
    <React.Fragment>
      <Modal show={bcCheckShowHide} size="lg">
        <Modal.Header
          closeButton
          onClick={() => handleBcCheckShowHide("", "")}
        >
          <Modal.Title>
            {bcType === "" && "Add Background Check"}
            {bcType === "edit" && "Internal Notes"}
            {bcType === "notify" && "Notify Candidate"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-secondary">
          <div className="row">
            {bcType === "edit" && (
              <div className="col-md-12 form-group">
                <label htmlFor="" className="form-control-label">
                  Notes
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="notes"
                  id="notes"
                  value={bcNotes}
                  placeholder="Notes"
                  onChange={({ currentTarget }) => setBcNotes(currentTarget.value)}
                />
              </div>
            )}
            {bcType === "notify" && (
              <div className="col-md-12 form-group">
                <label htmlFor="" className="form-control-label">
                  Notes
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="notes"
                  id="notes"
                  value={bcNotifyNotes}
                  placeholder="Notes"
                  onChange={({ currentTarget }) => setBcNotifyNotes(currentTarget.value)}
                />
              </div>
            )}
            {bcType === "edit" && (
              <div className="col-md-12 form-group form-inline">
                <div className="custom-control custom-radio mb-3">
                  <input
                    name="status"
                    className="custom-control-input"
                    id="activate"
                    type="radio"
                    checked={bcStatus === true}
                    //defaultChecked={bcStatus === true}
                    onChange={() => setBcStatus(true)}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="activate"
                  >
                    Pass
                  </label>
                </div>
                <div className="custom-control custom-radio mb-3 ml-3">
                  <input
                    name="status"
                    className="custom-control-input"
                    id="deactivate"
                    checked={bcStatus === false}
                    type="radio"
                    //defaultChecked={bcStatus === false}
                    onChange={() => setBcStatus(false)}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="deactivate"
                  >
                    Fail
                  </label>
                </div>
              </div>
            )}

            {(bcType === "edit" || bcType === "notify") && (
              <div className="col-md-12">
                <UploadDocument
                  documents={documents}
                  handleFileRemove={handleFileRemove}
                  onFileChange={onFileChange}
                ></UploadDocument>
              </div>
            )}
          </div>
        </Modal.Body>
        {bcType !== "" && (
          <Modal.Footer>
            <Button
              variant="outline-dark"
              size="sm"
              //disabled={saveBtnStatus || this.validate()}
              disabled={saveBtnStatus}
              onClick={doSubmit}
            >
              {saveBtnStatus ? (
                <i className="fa fa-circle-o-notch fa-spin mr-1"></i>
              ) : <i className="fa fa-check mr-1"></i>}
              Save
            </Button>
          </Modal.Footer>
        )}
      </Modal>

    </React.Fragment>
  );
}

export default AddBcChecks;
